import TextInput from "Components/molecule/inputs/text-input"
import ColorPickerInput from "Components/molecule/inputs/color-picker-input"
import CheckboxInput from "Components/molecule/inputs/checkbox-input"
import SearchSelect from "Components/molecule/inputs/search-select"
import { SelectOption } from "Components/molecule/inputs/select-input"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import SecondaryButton from "Components/atoms/buttons/secondary-button"
import FormProps from "data/forms"
import FormContainer from "Components/atoms/containers/form-container"
import DepartmentFields from "./types"

interface DepartmentFormProps extends FormProps<DepartmentFields> {
    departmentLevels: SelectOption[]
    parentDepartments: SelectOption[]
    employees: SelectOption[]
}

const CODE_KEY = "code";
const DESCRIPTION_KEY = "description";
const LEVEL_KEY = "departmentLevelId";
const PARENT_KEY = "parentDepartmentId";
const HEAD_KEY = "departmentHeadId";
const COLOR_KEY = "color";
const BILLABLE_KEY = "isBillable";

const DepartmentForm = ({
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    handleCancel,
    errors,
    isValid,
    touched,
    isSubmitting,
    departmentLevels,
    parentDepartments,
    employees,
    setFieldValue,
    edit
}: DepartmentFormProps) => {

    return <FormContainer
        inputs={<>
            <TextInput
                touched={!!touched.code}
                name={CODE_KEY}
                key={CODE_KEY}
                className="col-12 col-md-4"
                label={"Code*"}
                placeholder={"e.g. GEO"}
                value={values.code}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.code && !!errors.code}
                message={touched.code ? errors.code : undefined}
            />

            <TextInput
                touched={!!touched.description}
                name={DESCRIPTION_KEY}
                key={DESCRIPTION_KEY}
                className="col-12 col-md-4"
                label={"Description*"}
                placeholder={"e.g. Geotechnical"}
                value={values.description}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.description && !!errors.description}
                message={touched.description ? errors.description : undefined}
            />

            <SearchSelect
                name={LEVEL_KEY}
                key={LEVEL_KEY}
                className="col-12 col-md-4"
                label={"Department Level*"}
                placeholder={"Select a level"}
                value={values.departmentLevelId}
                error={!!touched.departmentLevelId && !!errors.departmentLevelId}
                message={touched.departmentLevelId ? errors.departmentLevelId : undefined}
                options={departmentLevels}
                onChange={(option: SelectOption | null) => handleChange(LEVEL_KEY)(option ? option.value : '')}
                onBlur={handleBlur(LEVEL_KEY)}
            />

            <SearchSelect
                name={PARENT_KEY}
                key={PARENT_KEY}
                className="col-12 col-md-4"
                label={"Parent Department"}
                placeholder={"Select a parent department"}
                value={values.parentDepartmentId}
                error={!!touched.parentDepartmentId && !!errors.parentDepartmentId}
                message={touched.parentDepartmentId ? errors.parentDepartmentId : undefined}
                options={parentDepartments}
                onChange={(option: SelectOption | null) => handleChange(PARENT_KEY)(option ? option.value : '')}
                onBlur={handleBlur(PARENT_KEY)}
                clearable
            />

            <SearchSelect
                name={HEAD_KEY}
                key={HEAD_KEY}
                className="col-12 col-md-4"
                label={"Department Head"}
                placeholder={"Search employee..."}
                value={values.departmentHeadId}
                error={!!touched.departmentHeadId && !!errors.departmentHeadId}
                message={touched.departmentHeadId ? errors.departmentHeadId : undefined}
                options={employees}
                onChange={(option: SelectOption | null) => handleChange(HEAD_KEY)(option ? option.value : '')}
                onBlur={handleBlur(HEAD_KEY)}
                clearable
            />

            <CheckboxInput
                name={BILLABLE_KEY}
                key={BILLABLE_KEY}
                className="col-12 col-md-2 align-self-end"
                label={"Billable"}
                checked={values.isBillable ?? true}
                onChange={(e) => setFieldValue?.(BILLABLE_KEY, e.target.checked)}
            />

            <ColorPickerInput
                name={COLOR_KEY}
                key={COLOR_KEY}
                className="col-12 col-md-2"
                label={"Colour"}
                value={values.color ?? ''}
                onBlur={handleBlur}
                onChange={(value: string) => handleChange(COLOR_KEY)(value)}
                error={!!touched.color && !!errors.color}
                message={touched.color ? errors.color : undefined}
                clearable
            />
        </>}

        buttons={<>
            <PrimaryButton
                className="col-12 col-md-6 col-lg-2"
                type='submit'
                onClick={() => handleSubmit()}
                disabled={isSubmitting || !isValid}
            >
                {isSubmitting ? "Saving...." : edit ? "Update" : "Save"}
            </PrimaryButton>
            {
                handleCancel &&
                <SecondaryButton
                    className="col-12 col-md-6 col-lg-2"
                    disabled={isSubmitting}
                    onClick={() => handleCancel()}
                >
                    Back
                </SecondaryButton>
            }
        </>}
    />
}

export default DepartmentForm
